import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/dealership/lib/api";
import { Button } from "@/components/ui/button";
import { Calculator } from "lucide-react";

/** Starts a desking worksheet prefilled from a vehicle / lead / appraisal / deal. */
export default function DeskDealButton({
  vehicleId, leadId, appraisalId, dealId, label = "Desk a deal",
  size = "default", variant = "outline", iconOnly = false, className = "", testid = "desk-a-deal-button",
}) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const start = async (e) => {
    e?.stopPropagation?.();
    setBusy(true);
    try {
      const { data: draft } = await api.get("/desking/prefill", {
        params: { vehicle_id: vehicleId || "", lead_id: leadId || "", appraisal_id: appraisalId || "", deal_id: dealId || "" },
      });
      const { totals, id, created_at, updated_at, created_by, converted_deal_id, ...payload } = draft;
      payload.name = draft.vehicle_desc || draft.customer_name || "New worksheet";
      const { data } = await api.post("/desking/worksheets", payload);
      navigate(`/dealership/desking/${data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start a worksheet");
    } finally {
      setBusy(false);
    }
  };

  if (iconOnly) {
    return (
      <Button variant="ghost" size="icon" onClick={start} disabled={busy} title={label} data-testid={testid} className={className}>
        <Calculator className="h-4 w-4 text-primary" />
      </Button>
    );
  }
  return (
    <Button variant={variant} size={size} onClick={start} disabled={busy} data-testid={testid} className={className}>
      <Calculator className="h-4 w-4 mr-2" />{busy ? "Starting…" : label}
    </Button>
  );
}
